import styled from "styled-components";
import Player from "@vimeo/player";
import { useEffect, useId } from "react";

import {
  BrandAssetType,
  CompanyProfileLinkFragment,
} from "@otta/search/schema";
import { breakpoints } from "@otta/design-tokens";

const Picture = styled.picture`
  display: flex;
`;

const Image = styled.img`
  object-fit: cover;
  max-width: 100%;
  flex: 1 1 0;
`;

const VideoContainer = styled.div`
  flex-grow: 1;
`;

function Video({
  source,
  className,
}: {
  source: string;
  className?: string;
}): React.ReactElement {
  const id = useId();

  useEffect(() => {
    const player = new Player(id, { id: source, responsive: true });
    return () => player.destroy();
  }, [id, source]);

  return <VideoContainer id={id} className={className} />;
}

export function Asset({
  className,
  asset: ba,
}: {
  className?: string;
  asset: CompanyProfileLinkFragment;
}): React.ReactElement | null {
  if (ba.companyBrandAsset.type === BrandAssetType.Vimeo) {
    return <Video source={ba.companyBrandAsset.source} className={className} />;
  }

  return ba.mobilePlacement ? (
    <Picture key={ba.id} className={className}>
      {!!ba.desktopPlacement && (
        <source
          media={`(min-width: ${breakpoints.tablet}px)`}
          srcSet={ba.desktopPlacement?.sourceSet ?? undefined}
          src={ba.desktopPlacement?.source ?? undefined}
        />
      )}

      <Image
        srcSet={ba.mobilePlacement.sourceSet ?? undefined}
        src={ba.mobilePlacement.source ?? undefined}
        alt={ba.companyBrandAsset.alt ?? undefined}
      />
    </Picture>
  ) : null;
}
